// [Route("/API/Role")];

import { ApiUtility } from "../../Utilities/ApiUtility.axios";
import { DBRecordStatusRole } from "./CustomerRoleServices";

class ClientRoleServices {
  private route = "/V1/API/Acc_ClientRole";

  getAllRoleIdNameList = (clientId: string[]) =>
    ApiUtility.get(`${this.route}/AllRoles`, { clientId });

  getRoleById = (clientId: string, roleId?: string) =>
    ApiUtility.get(`${this.route}/${clientId}/${roleId}`);

  getRoleList = (
    clientId: string,
    start: number,
    length: any,
    sortCol?: string,
    sortDir?: string,
    search?: string,
    status?: any,
    requestModel?: any
  ) =>
    ApiUtility.getResult(`${this.route}/${clientId}/GetList`, {
      start,
      length,
      sortCol,
      sortDir,
      search,
      status,
      requestModel,
    });

  postClientRole = (clientId: string, param: any, clientRoleId?: string) =>
    ApiUtility.postForm(
      `${this.route}/${clientId}${clientRoleId ? "/" + clientRoleId : ""}`,
      param
    );

  changeRoleStatus = (
    clientId: string,
    id: string,
    status: DBRecordStatusRole
  ) =>
    ApiUtility.postForm(
      `${this.route}/${clientId}/changeStatus?id=${id}&status=${status}`,
      {}
    );
}
export default new ClientRoleServices();
